<template>
  <div class="container-col collocation-group">
    <b-link @click.stop="remove()">
      <octicon name="x"/>
    </b-link>
    <b-link @click.stop="toggleVisibility()">
      <octicon name="eye" :class="visible ? 'visible' : 'hidden'"/>
    </b-link>
    <input :value="name" @change="update({ name: $event.target.value })" :class="{unnamed: name === defaultName }"/>
    <draggable :value="value.collocations" @input="update({ collocations: $event })" group="colls" draggable=".draggable-item" class="min-height" >
      <collocation v-for="lempos in value.collocations" :key="lempos" :lempos-string="lempos"
                  :pattern="pattern" :core-indexes="coreIndexes" :show-core="false" linkTarget="grouping" class="collocation draggable-item"/>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import Collocation from './Collocation.vue'
import Octicon from 'vue-octicon/components/Octicon.vue'
import 'vue-octicon/icons/x'
import 'vue-octicon/icons/eye'

export default {
  name: 'DraggableSemanticGroup',
  props: {
    value: Object,
    pattern: String,
    coreIndexes: Array,
    draggableGroup: {
      type: String,
      default: 'collocations'
    }
  },
  components: {
    draggable,
    Collocation,
    Octicon
  },
  computed: {
    visible: function () { return !(this.value.visible === false) },
    name: function () { return this.value.name ? this.value.name : this.defaultName },
    defaultName: function () { return 'مجموعة غير معنونة' }
  },
  methods: {
    update: function (g) {
      const gg = { ...this.value, ...g }
      console.log('Sending update for ' + gg.id, gg)
      this.$emit('input', gg)
    },
    remove: function () {
      console.log('Sending delete')
      this.$emit('delete')
    },
    toggleVisibility: function () {
      this.update({ visible: !this.visible })
    }
  }
}
</script>

<style scoped>
  input {
    border: 0px;
    border-bottom: 1px solid grey;
    background: none;
    font-size: 18px;
    font-weight: bold;
    margin: 5px;
    margin-bottom: 15px;
  }
  .unnamed {
    font-weight: normal;
    color: grey;
    font-style: italic;
  }
  .collocation-group {
      background-color:antiquewhite;
      border: 1px solid black;
      padding: 5px;
      display: flex;
      flex-direction: column;
      margin: 20px
  }
  .collocation-list {
    min-height: 20px;
  }
  div.collocation {
    background-color: lightgray
  }
  .visible {
    color: black
  }
  .hidden {
    color: grey
  }
</style>
